/**
 * Notification module types
 */

/**
 * Notification theme from database
 */
export interface NotificationTheme {
  id: string;
  name: string;
  gradient_start: string;
  gradient_middle: string | null;
  gradient_end: string;
  gradient_direction: string;
  corner_color_1: string;
  corner_color_2: string;
  sort_order: number;
  created_at: string;
}

/**
 * Notification type settings from database
 */
export interface NotificationTypeSetting {
  id: string;
  weekend_id: string;
  notification_type: NotificationType;
  theme_id: string | null;
  lottie_animation: string | null;
  title_template: string | null;
  body_template: string | null;
  is_enabled: boolean;
  send_push: boolean;
  created_at: string;
  updated_at: string;
}

/**
 * Supported notification types
 */
export type NotificationType = 
  | 'score'           // Points scored
  | 'event'           // Familie event created/updated
  | 'birthday'        // Birthday notification
  | 'challenge'       // New challenge set live
  | 'custom';         // Custom admin notification

/**
 * In-app notification from database
 */
export interface InAppNotification {
  id: string;
  user_id: string;
  type: string;
  title: string;
  body: string;
  action_url: string | null;
  action_data: Record<string, unknown> | null;
  is_read: boolean;
  read_at: string | null;
  sender_id: string | null;
  weekend_id: string | null;
  created_at: string;
  notification_type: string | null;
  lottie_animation: string | null;
  scheduled_at: string | null;
  is_sent: boolean;
  sent_at: string | null;
  delivery_method: string | null;
  event_id: string | null;
  priority: string | null;
  // Extended fields for celebration modal
  theme_id?: string | null;
  points?: number;
  user_name?: string;
  team_name?: string;
}

/**
 * Props for CelebrationModal
 */
export interface CelebrationModalProps {
  visible: boolean;
  onDismiss: () => void;
  notification: InAppNotification | null;
  theme?: NotificationTheme | null;
}

/**
 * Lottie animation mapping
 */
export interface LottieAnimationInfo {
  id: string;
  name: string;
  file: any; // require() result
  category: 'emoji' | 'celebration' | 'animal' | 'other';
}

/**
 * Template variables for notification text
 */
export interface NotificationTemplateVars {
  user_name?: string;
  team_name?: string;
  points?: number;
  event_title?: string;
  challenge_title?: string;
  [key: string]: string | number | undefined;
}


